
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

library.add( faFilter, faInfoCircle, faSearch, faTimes )

/**
 * CloseBtn - Inline
**/
const CloseBtn = (props) => {
  return <FontAwesomeIcon className='close-btn'
                          icon="fa-solid fa-times"
                          onClick={props.onClick}
                          style={{ color: 'var(--fff-secondary-emphasis-color)' }} />
}
export default CloseBtn